var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.025 0.960205H0V342.953H513V0.960205H197.025Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 73.0427L279.207 142.926H352.688L293.24 186.116L315.948 256.001L256.5 212.81L197.052 256.001L219.76 186.116L160.312 142.926H233.793L256.5 73.0427Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.956299)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVn);
export default __webpack_public_path__ + "static/media/VN.9a090bcfc42c32608fd3162d6d85aa4e.svg";
export { ForwardRef as ReactComponent };